import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { Address } from '~app/modules/checkout/models';
import { CartOfferLine } from '~shared/modules/shopping-cart-store';

export class PaymentCompletedApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.PaymentCompleted;

  constructor(private shippingAddress?: Address,
              private billingAddress?: Address,
              private paymentMethod?: string,
              private promoProduct? : CartOfferLine) {

  }

  getPayload(): any {
    return {
      shippingAddress: this.shippingAddress,
      billingAddress: this.billingAddress,
      paymentMethod: this.paymentMethod,
      promoProduct: this.promoProduct
    };
  }
}
